export const sortCaseInsensitiveAscPredicate = (a: string, b: string): number =>
  a.toUpperCase() > b.toUpperCase() ? 1 : -1;
